import type { TaskStatus, TaskTypeName } from 'src/gql/graphql';
import { isRequiredTaskStatus, isSignedRequiredOnboardingTask } from 'src/utils/client-roadmap';

export type ClientOnboardingActionTask = {
  readonly type: TaskTypeName | null | undefined;
  readonly status: TaskStatus | null | undefined;
  readonly onboardingTask: {
    readonly coClientDocusignSignedAt: string | null | undefined;
    readonly coClientIaaSignedAt: string | null | undefined;
    readonly primaryClientDocusignSignedAt: string | null | undefined;
    readonly primaryClientIaaSignedAt: string | null | undefined;
  } | null;
  readonly user: {
    readonly isPrimaryClient: boolean;
  };
};

function isPrerequisiteTaskType(type: TaskTypeName | null | undefined) {
  return type === 'initial_intake_form' || type === 'account_setup';
}

function isOutstandingTaskStatus(status: TaskStatus | null | undefined) {
  return status === 'todo' || status === 'in_progress';
}

export function clientOnboardingActionsComplete(tasks: readonly ClientOnboardingActionTask[] | null | undefined) {
  if (tasks === null || tasks === undefined) {
    return false;
  }
  const required = tasks.filter((task) => isRequiredTaskStatus({ status: task.status }));
  const onboardingTasks = required.filter((task) => task.type === 'onboarding_flow');

  if (onboardingTasks.length === 0) {
    return false;
  }
  const signed = onboardingTasks.every((task) =>
    isSignedRequiredOnboardingTask({
      docusignSignedAt: task.user.isPrimaryClient
        ? task.onboardingTask?.primaryClientDocusignSignedAt
        : task.onboardingTask?.coClientDocusignSignedAt,
      iaaSignedAt: task.user.isPrimaryClient
        ? task.onboardingTask?.primaryClientIaaSignedAt
        : task.onboardingTask?.coClientIaaSignedAt,
      status: task.status,
    }),
  );
  const prerequisitesOutstanding = required.some(
    (task) => isPrerequisiteTaskType(task.type) && isOutstandingTaskStatus(task.status),
  );

  return signed && !prerequisitesOutstanding;
}
